export default __webpack_public_path__ + "static/138-c48e0d99a8800d1facba9d21735a8449.jpg";